import callback from "../../../utils/prototypeDefinitions/Date.prototype.addDays";
import { lStorage } from "../../../utils/localStorage/lStorage";
import foodConfig from "../../FoodConstructor/config";
import {
  countEnergyInDay,
  countEnergyInProduct,
} from "../../FoodConstructor/utils/countEnergy";
import { getDay as getRoutineDay } from "../../Routine/utils";
import { getCheckedPeople } from "../../Relationships/utils";
import { getAllAnniversaries } from "../../Anniversaries/utils";
import { getCompletedTasks } from "../../../utils/server/GoogleTasks";
import { getDay } from "../../Routine/utils/serverDays";
import { loadChecked as loadCheckedAccumulative } from "../../Accumulative/utils/serverTasks";
import { number } from "prop-types";

callback();

const getPreviousMonday = (date = new Date()) => {
  return date.addDays(-1 * (date.getDay() - 1));
};

const getStartDate = (date = new Date()) => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);

  // return getPreviousMonday(date);
  return date;
};

const getEndDate = () => {
  const today = new Date();
  today.setHours(23);
  today.setMinutes(59);
  today.setSeconds(59);

  const possibleEnd = getPreviousMonday(today).addDays(6);

  return possibleEnd < Date.now() ? possibleEnd : new Date();
};

const getDays = (preferableStartDate) => {
  const startDate = getStartDate(preferableStartDate);
  const endDate = getEndDate();

  const days = [];

  for (let i = 0; startDate.addDays(i) < endDate && i < 3; i++) {
    days.push({
      date: startDate.addDays(i),
      md: [],
    });
  }

  return days;
};

const isSameDay = (rawDate1, rawDate2) => {
  const date1 = new Date(rawDate1);
  const date2 = new Date(rawDate2);

  return !!(
    date1.getDay() === date2.getDay() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

const getFoodHistory = async () => {
  const rawFoodHistory = (await lStorage.get("plan/food")) ?? [];
  const foodHistory = rawFoodHistory.map((rawDay) => {
    const day = {};

    const callbackCreator =
      (key) =>
      ({ id, weight }) => {
        const inConfig = foodConfig[key].find(
          (possibleProduct) => possibleProduct.id === id
        );

        return {
          id,
          weight,
          name: inConfig.name,
          energy: inConfig.energy,
        };
      };

    day.dayDate = rawDay.dayDate;
    day.grocery = rawDay.grocery.map(callbackCreator("grocery"));
    day.omegaFats = rawDay.omegaFats.map(callbackCreator("omegaFats"));
    day.protein = rawDay.protein.map(callbackCreator("protein"));
    day.tasty = rawDay.tasty.map(callbackCreator("tasty"));
    day.custom = rawDay.custom;

    return day;
  });

  return foodHistory;
};

const getTaggetPeople = async (date) => {
  const rawPeople = await getCheckedPeople();

  const people = [];

  rawPeople.forEach((person) => {
    person.contactingMoments.forEach((moment) => {
      if (isSameDay(new Date(date), new Date(moment))) {
        people.push({
          name: person.title,
          moment: moment,
        });
      }
    });
  });

  return people;
};

const getTimeString = (date) => {
  const addZerosIfNeeded = (number) =>
    number >= 10 ? String(number) : `0${number}`;

  const hours = addZerosIfNeeded(date.getHours());
  const minutes = addZerosIfNeeded(date.getMinutes());

  if (!isNaN(hours) && !isNaN(minutes)) {
    return `${addZerosIfNeeded(date.getHours())}:${addZerosIfNeeded(
      date.getMinutes()
    )}`;
  } else {
    return "unknown";
  }
};
const getDurationColoredStr = (miliseconds) => {
  const rawHours = miliseconds / 1000 / 60 / 60;
  const cleanHours = Math.floor(rawHours);
  const remains = rawHours % cleanHours;
  const remainsInMinutes = Math.floor(remains * 60);

  if (isNaN(rawHours)) {
    return `<mark style="background: #FF5582A6;">unknown</mark>`;
  } else if (rawHours < 6) {
    return `<mark style="background: #FFF3A3A6;">${cleanHours}год ${remainsInMinutes}хв</mark>`;
  } else if (rawHours >= 6 && rawHours <= 9) {
    return `<mark style="background: #BBFABBA6;">${cleanHours}год ${remainsInMinutes}хв</mark>`;
  } else {
    return `<mark style="background: #FF5582A6;">${cleanHours}год ${remainsInMinutes}хв</mark>`;
  }
};

const getAnniversaries = (date) => {
  const allAnniversaries = getAllAnniversaries();

  return allAnniversaries
    .filter((anniversary) =>
      isSameDay(new Date(date), new Date(anniversary.date))
    )
    .map(({ title }) => `- ${title}`)
    .join("\n");
};

const getHistoricalWeathers = async () => {
  return lStorage.get("analytics/weather");
};

const getRoutines = async (date) => {
  const routine = await getDay(date);

  return routine;
};

const getAccumulative = async (date) => {
  const allChecked = await loadCheckedAccumulative();

  const todayChecked = [];

  allChecked.forEach((task) => {
    task?.checkedMoments?.forEach((moment) => {
      if (isSameDay(new Date(moment), new Date(date))) {
        todayChecked.push(task.title);
      }
    });
  });

  return todayChecked;
};

const generateBeautifulDate = (date) => {
  const addZeroIfNeeded = (number) =>
    number < 10 ? `0${number}` : String(number);

  return `${date.getFullYear()}-${addZeroIfNeeded(
    date.getMonth() + 1
  )}-${addZeroIfNeeded(date.getDate())} (${date.getWeekDayName()})`;
};

export const generateReport = async (rawGForm, preferableStartDate) => {
  const gForm = JSON.parse(rawGForm ? rawGForm : "[]");
  const foodHistory = await getFoodHistory();

  const days = getDays(preferableStartDate);
  const promises = [];

  days.forEach(async ({ date, md }, index, arr) => {
    let resolver;
    const promise = new Promise((resolve) => (resolver = resolve));
    promises.push(promise);

    const routineToday = await getRoutineDay(date);
    const routineYesterday = await getRoutineDay(date.addDays(-1));

    const gFormRecord = gForm.find((record) =>
      isSameDay(
        date,
        record["Date"]
          ? new Date(record["Date"])
          : new Date(record["Timestamp"])
      )
    );
    const foodDay = foodHistory.find(({ dayDate }) =>
      isSameDay(new Date(dayDate), date)
    );

    const people = await getTaggetPeople(date);

    const anniversaries = getAnniversaries(date);

    const tasks = await getCompletedTasks(date);

    const routine = await getRoutines(date);

    const accumulative = await getAccumulative(date);

    const weather = (await getHistoricalWeathers()).find((day) =>
      isSameDay(day.date, date)
    );

    // #region md_pushes_end
    md.push(generateBeautifulDate(date));

    if (gFormRecord && gFormRecord["This day happiness level in general"]) {
      const value = gFormRecord["This day happiness level in general"];
      const getDayName = (number) => {
        return {
          1: `<mark style="background: #FF5582A6;">The worst day in life</mark>`,
          2: `<mark style="background: #FF5582A6;">Gutted</mark>`,
          3: `<mark style="background: #FF5582A6;">Very bad</mark> `,
          4: `<mark style="background: #FFB86CA6;">Bad</mark> `,
          5: `<mark style="background: #FFB86CA6;">Well</mark> `,
          6: `<mark style="background: #FFF3A3A6;">Almost fine</mark> `,
          7: `<mark style="background: #FFF3A3A6;">Fine</mark> `,
          8: `<mark style="background: #BBFABBA6;">Very good</mark>`,
          9: `<mark style="background: #BBFABBA6;">Almost perfect</mark> `,
          10: `<mark style="background: #ABF7F7A6;">Best day in the life</mark> `,
        }[number];
      };
      md.push(
        `\nGeneral day happines level: **${value}** / 10\n${getDayName(
          value
        )}\n#note/dayWithReport`
      );
    } else if (
      !gFormRecord ||
      !gFormRecord["This day happiness level in general"]
    ) {
      md.push(
        `\n#note/dayWithNoReport\n<mark style="background: #CACFD9A6;">custom report is absent</mark>`
      );
    }

    if (gFormRecord && gFormRecord["Short answer"]) {
      md.push(
        `\n\n\`\`\`ad-abstract\ntitle: Quick report\n\n${gFormRecord["Short answer"]}\n\n\`\`\``
      );
    }

    if (gFormRecord) {
      const work = gFormRecord["Work aspect"] ?? 0;
      const soul = gFormRecord["Soul aspect"] ?? 0;
      const health = gFormRecord["Health aspect"] ?? 0;
      const love = gFormRecord["Love aspect"] ?? 0;
      const friendship = gFormRecord["Friendship aspect"] ?? 0;
      const utitlities = gFormRecord["Utilities aspect"] ?? 0;
      const hobbies = gFormRecord["Hobbies aspect"] ?? 0;
      const finances = gFormRecord["Financial feelings at end of the day"] ?? 0;

      const chart = `\`\`\`chart\ntype: polarArea\nlabels: [Work, Soul, Health, Love, Friendship, Utilities, Hobbies, Financial]\nseries:\n  - title: Work, Soul, Health, Love, Friendship, Utilities, Hobbies, Financial\n    data: [${work}, ${soul}, ${health}, ${love}, ${friendship}, ${friendship}, ${utitlities}, ${hobbies}]\ntension: 0.2\nwidth: 75%\nlabelColors: true\nfill: false\nbeginAtZero: true\n\`\`\``;

      md.push(`\n\n# Happiness Wheel\n${chart}`);
    }

    if (
      gFormRecord &&
      (gFormRecord["Keypoints"] || gFormRecord["Keypoints description"])
    ) {
      const keypoints = gFormRecord["Keypoints"].split(";");
      const description = gFormRecord["Keypoints description"];

      md.push(`\n\n# Keypoints`);

      if (keypoints.length) {
        md.push("\n" + keypoints.join(" \n"));
      }

      if (description) {
        md.push("\n\n" + description);
      }
    }

    if (
      gFormRecord &&
      (gFormRecord["Notes types"] || gFormRecord["Notes description"])
    ) {
      const motesTypes = gFormRecord["Notes types"].split(";");
      const description = gFormRecord["Notes description"];

      md.push(`\n\n# Notes`);

      if (motesTypes.length) {
        md.push("\n" + motesTypes.join(" \n"));
      }

      if (description) {
        md.push("\n\n" + description);
      }
    }

    if (gFormRecord) {
      const projectsKeys = Object.keys(gFormRecord).filter(
        (key) => key.slice(0, 2) === "p3"
      );

      if (projectsKeys.filter((key) => !!gFormRecord[key]).length) {
        md.push("\n\n# Projects updates");
      }

      projectsKeys.forEach((key) => {
        const value = gFormRecord[key];

        if (value) {
          md.push(`\n\n#### ${key}\n${value}`);
        }
      });
    }

    if (gFormRecord && gFormRecord["Which thought had been posses me?"]) {
      md.push(
        `\n\n# Long day description\n${gFormRecord["Which thought had been posses me?"]}`
      );
    }

    md.push("\n\n# Autogenerated reports");

    if (weather) {
      const renderTemp = (time) =>
        `**${time.temp}°C**, **${time.descr}**, вітер ${time.wind}м/с`;

      md.push(
        `\n\`\`\`ad-question\ntitle: Weather\ncollapse: closed\n\n🌅 sunrice: ${getTimeString(
          new Date(weather.sunrice)
        )}\n🌇 sunset : ${getTimeString(
          new Date(weather.sunset)
        )}\n\n04:00 : ${renderTemp(weather.morningNigh)}\n09:00 : ${renderTemp(
          weather.morning
        )}\n13:00 : ${renderTemp(weather.noon)}\n18:00 : ${renderTemp(
          weather.evening
        )}\n21:00 : ${renderTemp(weather.eveningNight)}\n\`\`\``
      );
    }

    if (tasks?.length || accumulative) {
      md.push(
        `\n\`\`\`ad-report\ntitle: Google & Accumulative Tasks completed:\ncollapse: open\n\nGoogle tasks:\n${
          tasks?.length
            ? `${tasks
                .map(
                  (task) =>
                    `- ✔ ${getTimeString(new Date(task.completed))} ${
                      task.title
                    }${task.notes ? `\nnotes: ${task.notes}` : ""}`
                )
                .join("\n")}\n`
            : ""
        }\n${
          accumulative.length
            ? `Accumulative:\n${accumulative
                .map((task) => `- ✔ ${task}`)
                .join("\n")}`
            : ""
        }\n\`\`\`\n`
      );
    }

    if (routine && accumulative) {
      const renderTask = (task) =>
        `- ${task.isCompleted ? "✔" : "❌"} ${
          task.momentOfCompletion
            ? `${getTimeString(new Date(task.momentOfCompletion))} `
            : ""
        }${task.title}`;

      md.push(
        `\n\`\`\`ad-report\ntitle: Routines:\ncollapse: closed\n\nMorning:\n${routine.morning
          .map(renderTask)
          .join("\n")}\n\nEvening:\n${routine.evening
          .map(renderTask)
          .join("\n")}\n\`\`\`\n`
      );
    }

    // #engregion md_pushes_end

    resolver();
  });

  await Promise.all(promises);

  return days.map((day) => ({ ...day, md: day.md.join("") }));
};
